import { physicalDto } from '../dto/physicalDto';
import { tableViewModel } from '../views/tableViewModel';

export class physicalVMsTransformer {
  public static from(physicalVMsData: physicalDto): tableViewModel[] {
    return <tableViewModel[]>[
      {
        name: 'Total VMs',
        value: physicalVMsData.vmCount == null ? '-' : physicalVMsData.vmCount
      },
      {
        name: 'Running VMs',
        value: physicalVMsData.runningVMs == null ? '-' : physicalVMsData.runningVMs
      },
      {
        name: 'VM to Host Ratio',
        value: physicalVMsData.vMsToHostRatio == null ? '-' : physicalVMsData.vMsToHostRatio
      }
    ];
  }
}
